import { createAction } from 'redux-actions';
export const SET_LOADING_SERVICES_PARAMS = 'SET_LOADING_SERVICES_PARAMS';
export const ADD_LOADING_SERVICE_PARAM = 'ADD_LOADING_SERVICE_PARAM';
export const CLEAR_LOADING_SERVICES_PARAMS = 'CLEAR_LOADING_SERVICES_PARAMS';
export const setLoadingServicesParams = createAction(SET_LOADING_SERVICES_PARAMS);
export const addLoadingServiceParam = createAction(ADD_LOADING_SERVICE_PARAM);
export const clearLoadingServicesParams = createAction(CLEAR_LOADING_SERVICES_PARAMS);
